import CircleLoader from 'components/common/CircleLoader';
import { useOrganizationCredits } from 'hooks/backend/billing';

const OrganizationCredits = ({
  organizationId,
}: {
  organizationId: number;
}) => {
  const { isLoadingCredits, orgCredits } = useOrganizationCredits({
    organizationId,
  });

  return (
    <div className="flex">
      <div className="flex mt-3 text-m text-gray-600">
        Credits:
        <div className="mx-2">
          {isLoadingCredits ? (
            <CircleLoader isColored={true} />
          ) : (
            orgCredits?.totalCreditAmount
          )}
        </div>
      </div>
    </div>
  );
};

export default OrganizationCredits;
